import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Vote, LogOut, X, ChevronRight,
  BarChart3, Shield, Activity, MapPin
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import clsx from 'clsx';

const navItems = [
  {
    label: 'Dashboard',
    to   : '/admin/dashboard',
    icon : LayoutDashboard,
  },
  {
    label: 'Elections',
    to   : '/admin/elections',
    icon : Vote,
  },
  {
    label: 'Activity Log',
    to   : '/admin/audit-log',
    icon : Activity,
  },
  {
    label: 'Peta Sebaran Voter',
    to   : '/admin/voter-map',
    icon : MapPin,
  },
];

export default function Sidebar({ isOpen, onClose }) {
  const { adminUser, adminLogout } = useAuth();

  return (
    <aside
      className={clsx(
        'fixed inset-y-0 left-0 z-30 w-64 bg-primary-800 text-white flex flex-col',
        'transition-transform duration-300 ease-in-out',
        'lg:relative lg:translate-x-0',
        isOpen ? 'translate-x-0' : '-translate-x-full'
      )}
    >
      {/* Logo */}
      <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <Vote size={20} className="text-white" />
          </div>
          <div>
            <span className="font-bold text-lg leading-tight block">VotingOnline</span>
            <span className="text-xs text-blue-200 block">Admin Panel</span>
          </div>
        </div>
        <button
          onClick={onClose}
          className="lg:hidden text-white/60 hover:text-white p-1 rounded-lg transition"
        >
          <X size={18} />
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.to + item.label}
            to={item.to}
            onClick={onClose}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium',
                'transition-all duration-200 group',
                isActive
                  ? 'bg-white/20 text-white'
                  : 'text-blue-200 hover:bg-white/10 hover:text-white'
              )
            }
          >
            <item.icon size={18} className="flex-shrink-0" />
            <span className="flex-1">{item.label}</span>
            <ChevronRight
              size={14}
              className="opacity-0 group-hover:opacity-60 transition-opacity -translate-x-1 group-hover:translate-x-0 duration-200"
            />
          </NavLink>
        ))}
      </nav>

      {/* User Profile + Logout */}
      <div className="px-3 py-4 border-t border-white/10">
        {/* User info */}
        <div className="flex items-center gap-3 px-3 py-2.5 mb-2">
          <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
            {adminUser?.name?.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-white truncate">{adminUser?.name}</p>
            <p className="text-xs text-blue-300 truncate flex items-center gap-1">
              <Shield size={10} />
              {adminUser?.role === 'superadmin' ? 'Super Admin' : 'Admin'}
            </p>
          </div>
        </div>

        <button
          onClick={adminLogout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm font-medium
                     text-blue-200 hover:bg-danger-600 hover:text-white
                     transition-all duration-200"
        >
          <LogOut size={16} />
          <span>Keluar</span>
        </button>
      </div>
    </aside>
  );
}
